/**
 * How a goal is named on every screen that lists one (student, teacher, parent).
 * Web (dijipo-web-main/…/src/utils/goalLabel.ts) and mobile (dijipo-mobile/utils/goalLabel.ts)
 * keep byte-for-byte identical copies — change both.
 *
 * Since 2026-10 a goal has a typed name (`title`) and that is its headline; the
 * ders and konu move to a second line (goalScopeLabel). Older goals have no
 * name: "Matematik - Açılar" when a konu was picked, "Matematik" when only a
 * ders, the goal type's title as the last resort ("Günlük Soru Hedefi").
 *
 * The konu is `subject_units.title` (the column), not `.name`.
 */
interface GoalLike {
  title?: string | null;
  subject_name?: string | null;
  goal_definitions?: { title?: string | null; subjects?: { name?: string | null } | null } | null;
  subject_units?: { title?: string | null; subjects?: { name?: string | null } | null } | null;
}

export function goalSubjectName(g: GoalLike): string | null {
  return g.subject_name || g.goal_definitions?.subjects?.name || g.subject_units?.subjects?.name || null;
}

/** "Matematik - Türev", "Matematik", or null for a goal that spans every ders. */
export function goalScopeLabel(g: GoalLike): string | null {
  const subject = goalSubjectName(g);
  const konu = g.subject_units?.title || null;
  if (subject && konu) return `${subject} - ${konu}`;
  return subject || konu || null;
}

export function goalHeadline(g: GoalLike, fallback = 'Hedef'): string {
  const title = g.title?.trim();
  if (title) return title;
  return goalScopeLabel(g) || g.goal_definitions?.title || fallback;
}

/**
 * The line under a named goal's headline: its ders/konu, or "Tüm dersler".
 * Null for an older, unnamed goal — its headline already is the ders/konu.
 */
export function goalScopeLine(g: GoalLike): string | null {
  if (!g.title?.trim()) return null;
  return goalScopeLabel(g) ?? 'Tüm dersler';
}
